import React from "react";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import styles from "./mobileFilter.module.scss";
import RoadLayerSelection from "./roadLayerSelection";
import TradingPlacesViewModel from "../../../viewModels/tradingPlaces/tradingPlacesViewModel";
import { observer } from "mobx-react-lite";
import TradingPlacesFilter from "./tradingPlacesFilter";

interface MobileFilterProps {
  vm: TradingPlacesViewModel;
}

const MobileFilter = observer(({ vm }: MobileFilterProps) => {
  if (!vm.mobileFilterOpen) {
    return (
      <div className={styles.mobileFilterContainer}>
        <div className={styles.openButton} onClick={vm.toggleMobileFilter}>
          <Icon icon={IconType.CogWheel} className={styles.cogWheelIcon} />
        </div>
      </div>
    );
  }
  return (
    <div className={styles.mobileFilterContainer}>
      <div className={styles.filters}>
        <div className={styles.closeButton} onClick={vm.toggleMobileFilter}>
          <Icon icon={IconType.Cross} className={styles.closeIcon} />
        </div>
        <section className={styles.section}>
          <h3 className={styles.heading}>{vm.translate("headingTollRoads")}</h3>
          <RoadLayerSelection vm={vm} />
        </section>
        <div className={styles.divider} />
        <section className={styles.section}>
          <h3 className={styles.heading}>{vm.translate("headingSalesPoints")}</h3>
          <TradingPlacesFilter vm={vm} />
        </section>
      </div>
    </div>
  );
});

export default MobileFilter;
